import { DefaultRestService } from '@sydle/ui-api';

export const USER_AUTH = { login: 'test', password: 'testpasswordfortests' };
export const ORG_ID = '610a9ffe55b3e029bafd9cb8';
export const ORG_IDENTIFIER = 'sydle-one-platform-dev';
export const APPLICATION_IDENTIFIER = 'test';
export const BASE_URL = 'https://sydle-one-platform-dev.sydle.one/api/1/';
export const DEFAULT_LANGUAGE = 'pt';
export const APP_TOKEN =
  'eyJjdHkiOiJKV1QiLCJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..RD8GpP5CewoSqiEPacC0NQ.h9EqRBfu0UJ1PrGOwDXxSurJWYxqV_MvHlq2txlIl5wlX_GEuj0S9ntXQfw9FhJ-Rcff42mmIMIFVp0WFZbEnaX6_YExHT_KNKzTzjg0ha8lxTTn8kO46EIjO3hdb2Ib6O92NxjIOxv1_M-6_YbiC25VwAa6LnBPFzC4dbIppxLH55sL4mh3vGfI1l2EOSXgejQWFM4kEA1Geiw5ovD3U9w-31xEHytnGkz1Xau-rzFPwKD50O3rhIyDG71uB4AP6MhsIoSYjG4ZSM5oVLcTOFeBMIkC318qjI5vNOu0-X_Pf0bIyRHT-uZuAYYZUT-WiySgELAEtia009hWkQOezaxZwDilkoNTsJBfJzN_JOv1vvqp4te2U3xX_oL9i2cAvvFPyxSa3IbDZRnSHtMTZJsUBgq_56qamqJS4NDFtmWr55W74Jne4gIoTWAl0exlA-YLX3uKcVK4-M2pXd69i_LgIyLz2uK_EKpxq4U1UVyPWYOgASzv4bdduMPPYcLRou3UpM-Y73Czt42JsVVRRUaKBzcuLOZc8xYP4ES9I0EqHsQs3LUmDWLDI9qvsuYUHufDXxhkc7HQ6Q843sDYoHonj0GtaDR1BqWnSHxbt1o.zq6-fsGOFuNqYZazJjCG-w';
export const ADMIN_USER_GROUP = {
  _id: '000000000000000000000039',
  _classId: '000000000000000000000005',
};
export const TEST_USER = {
  _id: '639b07ba8ff7a01cd7ecad7a',
  _classId: '000000000000000000000002',
};

export const DEFAULT_REST_SERVICE = new DefaultRestService({
  app: APPLICATION_IDENTIFIER,
  baseUrl: BASE_URL,
  language: DEFAULT_LANGUAGE,
});
export const TRANSLATION_BUNDLE_IDENTIFIER = 'WORKSPACE_MESSAGES';
export const TRANSLATE_KEY = 'UPLOADED_FILE.DOWNLOAD';

export const CLASS_ID_NOT_CREATED = '123123123123123123123123';
export const OBJECT_ID_NOT_CREATED = '123123123123123123123123';

/**
 ********************************************************************
 * FieldReference test constants
 ********************************************************************
 */

export const FIELD_REFERENCE_CLASS_ID = '6610512ef52f0e76d5d9442c';

export const MESSAGE_CLASS_ID = '5d1a2f1a5b36d77b4a3c6ade';

export const MESSAGE_BODY_INTERFACE_ID = '6115585b8f98e638da7c8002';

// Segue a interface "Message Body"
export const TEST_PATH_BODY_CLASS_ID = '6618017ac26c64797ce2531d';

export const TEST_PATH_CLASS_ID = '66140d021606450ad11bdc27';

export const MESSAGE_CLASS_EXPIRATION_DATE_FIELD_ID = '5d36029da0d7dd40de953a91';

export const MESSAGE_CLASS_CREATION_USER_FIELD_ID = '00ff00000000000000000150';

export const ACL_USER_INTERFACE_PHOTO_FIELD_ID = '00ff00000000000000000166';

export const TEST_PATH_BODY_CLASS_CREATION_DATE_FIELD_ID = '00ff00000000000000000113';

// Referencia a interface "Message Body"
export const MESSAGE_CLASS_BODY_FIELD_ID = '5d48b8bea689ab3d94822679';

// Referencia a interface "Message Body"
export const TEST_PATH_BODY_CLASS_BODY_FIELD_ID = '65f8e0541db3a406f504b236';

// Referencia a interface "Test Path Interface"
export const TEST_PATH_CLASS_REFERENCE_FIELD_ID = '66140baaf52f0e76d51b2208';

// Referencia a interface "Message Body"
export const TEST_PATH_INTERFACE_BODY_FIELD_ID = '66140bde1606450ad1171020';

// Classe para testes de agregação
export const AGGREGATION_TEST_CONSTANTS = {
  CLASS_ID: '6451368ed0b3583f67c551bb', // Dados de Teste (Analytics de Venda de Produtos)
  INTEGER_FIELD: '64513442ff071e2f9a819577', // Quantidade vendida (Un)
  DOUBLE_FIELD: '64513469d0b3583f67b0f7a5', // Preço/Unidade
  LONG_FIELD: '6615954bc26c64797cabca47', // Tempo de venda (minutos)
  MULTIPLE_FIELD: '661425c2f52f0e76d5669e68', // Tempo entre vendas (minutos)
  DATE_FIELD: '645133a7ff071e2f9a7b29e0', // Data
  DATE_TIME_FIELD: '660fdfa2d7bf273398b4beb2', // Data/Hora das compras
  STRING_FIELD: '64513395d0b3583f67a5e3bd', // Produto
  GEOPOINT_FIELD: '645a95cf44efe85551a04e67', // Localização da venda
  INTERFACE_FIELD: '661593a2c26c64797c8ef417', // Interface
  MULTIPLE_REFERENCE_FIELD: '6615967e7ae66106bb2d1c5f', // Referencia dos Compradores
  MULTIPLE_REFERENCE_FIELD_NAME: '6615967e7ae66106bb2d1c5f.00ff00000000000000000147', // Referencia dos Compradores > Nome
  HIDDEN_FIELD: '661fb98d55f2677380b5340f', // Campo estaticamente oculto
  ADVANCED_FIELD: '661fb99f55f2677380b5b3b1', // Campo avançado
  DECIMAL_FIELD_INSIDE_CONCRETIZE_CLASS: '661593a2c26c64797c8ef417.:6621190b54adfb410de07055:662118d955f267738032d0b1', // Interface > Valor dec
  DATE_FIELD_INSIDE_CONCRETIZE_CLASS: '661593a2c26c64797c8ef417.:6621190b54adfb410de07055:662118ca54adfb410dd6dccf', // Interface > Data
  SIMPLE_CLASS_REF: '66bb91c247a4431b2a563739', // Referência à visitas no site
};

export const ALL_FIELDS_CLASS = {
  CLASS_ID: '6728c1821cde546c8b00626c', //Teste todos os campos - Analytics
  SIMPLE_STRING_TEXT: '6421e265f3ec2138e32e57fb', //Simple String Text
  SIMPLE_STRING_TEXT_MULTI: '661d5c7c55f2677380c9b8b7', //Simple String Text Multi
  LONG_STRING_TEXT: '65202830bb5a71009a825796', //Long String Text
  LONG_STRING_TEXT_MULTI: '661d5c7c55f2677380c9b8b4', //Long String Text Multi
  HTML_STRING_TEXT: '6520283cbb5a71009a82c362', //Html String Text
  HTML_STRING_TEXT_MULTI: '661d5c7c55f2677380c9b8b1', //Html String Text Multi
  MARKDOWN_STRING_TEXT: '652072f687b7fc6bb6246ed8', //Markdown String Text
  MARKDOWN_STRING_TEXT_MULTI: '661d5c7c55f2677380c9b8ae', //Markdown String Text Multi
  SCRIPT_STRING_TEXT: '652072f987b7fc6bb6248047', //Script String Text
  SCRIPT_STRING_TEXT_MULTI: '661d5c7c55f2677380c9b8ab', //Script String Text Multi
  LINK_STRING_TEXT: '652072fd87b7fc6bb6249294', //Link String Text
  LINK_STRING_TEXT_MULTI: '661d5c7c55f2677380c9b8a8', //Link String Text Multi
  BOOLEAN: '649c3bd0bdacae46bfeb6424', //Boolean
  BOOLEAN_MULTI: '661d5ceadf0c350da25dcee8', //Boolean Multi
  DATE: '6421e27df3ec2138e32e93ab', //Date
  DATE_MULTI: '661d5d1655f2677380dc1a12', //Date Multi
  NUMBER: '6421e28cf3ec2138e32eaf05', //Number
  NUMBER_MULTI: '661d8d5954adfb410d27862e', //Number Multi
  LONG_NUMBER: '661d8d8054adfb410d281a4e', //Long Number
  LONG_NUMBER_MULTI: '661d8da555f2677380ec392a', //Long Number Multi
  DECIMAL: '661d8dc255f2677380ec7ee9', //Decimal
  DECIMAL_MULTI: '661d8ddb55f2677380ece3d6', //Decimal Multi
  SIMPLE_REFERENCE: '661d927455f26773801fe888', //Simple Reference
  SIMPLE_REFERENCE_MULTI: '661d929454adfb410d542711', //Simple Reference Multi
  EMBEDDED_REFERENCE: '6421e2a9f3ec2138e32ec6ec', //Embedded Reference
  EMBEDDED_REFERENCE_MULTI: '661dcaad55f2677380d1a3d4', //Embedded Reference Multi
  EMBEDDED_REFERENCE_TABLE: '661e633155f2677380a23643', //Embedded Reference Table
  GEOPOINT: '661dceb054adfb410d0af2de', //Geopoint
  GEOPOINT_MULTI: '661dcfd155f2677380d52034', //Geopoint Multi
  AVANCADO: '65cf9fb39a62f030e831e1c7', //Avançado
  INTERFACE: '672a0ab81cde546c8bdb2347', //Interface
  INTERFACE_MULTI: '672a0ad01cde546c8bdbeb27', //Interface Multi
  HIDDEN: '672a0d9a1cde546c8bea8d05', //Hidden
};
